import React from 'react';

export const PERF_CHART = {
  accent: '#C42126',
  accentLight: '#e85a5e',
  green: '#09BD3C',
  greenDark: '#00a854',
  muted: '#64748b',
  grid: 'rgba(15, 23, 42, 0.06)',
};

export const STATUS_BAR_FILLS = [
  '#C42126',
  '#d6383d',
  '#a81b20',
  '#e85a5e',
  '#8b1519',
  '#09BD3C',
];

export const DUE_BAR_FILLS = {
  overdue: '#C42126',
  due_in_7_days: '#f59e0b',
  not_due: '#09BD3C',
  due_today: '#6366f1',
};

export const MONTH_STATUS_COLORS = {
  'In Progress': '#C42126',
  Pending: '#64748b',
  Partial: '#e85a5e',
  Paused: '#f59e0b',
  Blocked: '#94a3b8',
  Completed: '#09BD3C',
};

export const MONTH_STATUS_KEYS = [
  'In Progress',
  'Pending',
  'Partial',
  'Paused',
  'Blocked',
  'Completed',
];

export const CHART_AXIS_TICK = {
  fill: PERF_CHART.muted,
  fontSize: 11,
  fontWeight: 500,
};

export const CHART_MARGIN = {
  simple: { top: 20, right: 12, left: 0, bottom: 8 },
  stacked: { top: 16, right: 12, left: 0, bottom: 4 },
};

export function ChartGradientDefs() {
  return (
    <defs>
      <linearGradient id="perfGradAccent" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={PERF_CHART.accentLight} stopOpacity={0.95} />
        <stop offset="100%" stopColor={PERF_CHART.accent} stopOpacity={1} />
      </linearGradient>
      <linearGradient id="perfGradGreen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#34d399" stopOpacity={0.95} />
        <stop offset="100%" stopColor={PERF_CHART.green} stopOpacity={1} />
      </linearGradient>
    </defs>
  );
}

export function PerformanceChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  return (
    <div className="performance-chart-tooltip">
      {label ? <div className="performance-chart-tooltip__label">{label}</div> : null}
      <ul className="performance-chart-tooltip__list">
        {payload.map((entry) => (
          <li key={entry.name || entry.dataKey}>
            <span
              className="performance-chart-tooltip__dot"
              style={{ background: entry.color || entry.fill }}
            />
            <span className="performance-chart-tooltip__name">{entry.name}</span>
            <span className="performance-chart-tooltip__value">{entry.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ChartValueLabel(props) {
  const { x, y, width, value } = props;
  if (value == null || value === 0) return null;
  return (
    <text
      x={x + width / 2}
      y={y - 8}
      fill={PERF_CHART.accent}
      textAnchor="middle"
      fontSize={11}
      fontWeight={700}
    >
      {value}
    </text>
  );
}

export const CHART_GRID_PROPS = {
  stroke: PERF_CHART.grid,
  strokeDasharray: '4 6',
  vertical: false,
};
